export interface PhotoInputFileLoadEnd {
    eventName?: string;
    base64image: string;
    metadata: Record<string, any>;
}
